import styled from "styled-components"

import { Box } from "components/common/index"

const FieldWrapper = styled(Box).attrs(props => ({
  mb: props.mb || 2
}))`
  width: 100%;
  text-align: left;
  ${({ theme }) => theme.mediaQueries.tablet`
    display: flex;
    align-items: flex-start;
    justify-content: flex-end;
  `};
  &:last-child {
    margin-bottom: 0;
  }
`

export default FieldWrapper
